const labels = {
  All: { 'See the offering': 'See the offering' },
  FacilityDetails: { 'Ref: Page title': 'Facility Details', 'Ref: Review': 'Review' },
  FacilitiesList: { 'Ref: Page title': 'Facilities', 'Ref: See details': 'See details' },
};
export default labels;
